import { gql } from '@apollo/client';
import React, { useState, useCallback } from 'react';
import { AspectRatioBox, Overlay, ControlLink, Clickable } from '@moda/om';
import { useParams } from 'react-router-dom';
import isTouchDevice from 'is-touch-device';
import { Image } from '../../../Image';
import { LookCellFragment } from '../../../../generated/types/LookCellFragment';
import { hrefFor } from '../../../../routers';

import './LookCell.scss';

export const LOOK_CELL_FRAGMENT = gql`
  fragment LookCellFragment on Look {
    id
    name
    trunkshowSlugs: trunkshow_slugs
    trunkshowId: trunkshow_id
    primaryImageUrls: primary_image_urls {
      src: main
    }
  }
`;

enum Mode {
  Resting,
  Hovered
}

interface Props {
  look: LookCellFragment;
}

export const LookCell: React.FC<Props> = ({ look }) => {
  const [mode, setMode] = useState(Mode.Resting);

  const { vertical = 'women' } = useParams<{ vertical?: string }>();

  const handleMouseEnter = useCallback(() => {
    if (isTouchDevice()) return;
    setMode(Mode.Hovered);
  }, []);

  const handleMouseLeave = useCallback(() => {
    if (isTouchDevice()) return;
    setMode(Mode.Resting);
  }, []);

  if (!look.primaryImageUrls?.src) return null;

  const href: string | undefined =
    look.trunkshowId && look.trunkshowSlugs && look.trunkshowSlugs.length > 0
      ? hrefFor.LookviewPage({
          vertical: vertical,
          trunkshowSlug: `${look.trunkshowSlugs[0]}`,
          trunkshowId: `${look.trunkshowId}`,
          lookId: look.id
        })
      : undefined;

  return (
    <div
      className="LookCell"
      data-pk={look.id}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Clickable to={href}>
        <AspectRatioBox maxHeight={540} maxWidth={340}>
          <Image
            className="LookCell__image"
            src={look.primaryImageUrls.src}
            alt={look.name || 'Shop Look'}
            width="180"
            height="320"
          />
        </AspectRatioBox>

        <Overlay show={mode === Mode.Hovered && href !== undefined}>
          <ControlLink underlined={false} to={href}>
            SHOP LOOK
          </ControlLink>
        </Overlay>
      </Clickable>
    </div>
  );
};
